import { Deserializable } from "../shared/models/deserializable.model";
import { Decimal } from 'decimal.js';

export class Payment implements Deserializable {
  id: number;
  label: string;
  amount: number;
  type: 'CASH' | 'TFX' | 'CARD';
  paymentDate: string;
  invoiceId: number;
  stripePaymentIntentId?: string;
  stripeChargeId?: string;
  stripeSessionId?: string;
  stripeBrand?: string;
  stripeLast4?: string;

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }

  getDisplayedAmount() {
    return this.amount / 100;
  }

  get isStripe(): boolean {
    return !!(this.stripePaymentIntentId || this.stripeSessionId || this.stripeChargeId);
  }

  getFormattedPaymentDate() {
    // Implement formatting logic for paymentDate if needed
  }
}
